import { useQueryClient } from '@tanstack/react-query'
import { Form, Formik } from 'formik'
import { useState } from 'react'
import * as Yup from 'yup'
import { useApiCommitTfa } from '../../api/account/apiUsers'
import { ApiError, EntityModelResponseContainerAdminUserDto } from '../../generated'
import { Button } from '../../genericComponents/Button'
import { Card } from '../../genericComponents/Card'
import { InputGreenNoDecoration } from '../../inputs/InputGreenNoDecoration'
import { FTUWizardHeader } from '../components/FTUWizardHeader'
import { WizardWrapper } from '../WizardWrapper'

export const FTUVerifyCard = (props: { setQrCodeRead: (read: boolean) => void }) => {
  const { setQrCodeRead } = props

  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const queryClient = useQueryClient()

  const { mutate: commitTfa } = useApiCommitTfa()

  const validationSchema = Yup.object().shape({
    code: Yup.string().required('Code is required'),
  })

  const handleSubmit = (
    values: { code: string },
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    commitTfa(
      {
        verificationCode: values.code,
      },
      {
        onError: (error) => {
          const errorData = error as ApiError
          setErrorMessage(errorData.message || 'Incorrect code. Please try again.')
          setSubmitting(false)
        },
        onSuccess: (adminUser: EntityModelResponseContainerAdminUserDto) => {
          if (adminUser._embedded?.tfaEnabled == false) {
            setErrorMessage('Incorrect code. Please try again.')
            setSubmitting(false)
          } else {
            void queryClient.invalidateQueries({ queryKey: ['registrationState'] })
          }
        },
      }
    )
  }

  return (
    <Card title="">
      <WizardWrapper>
        <h1 className="text-primary font-bold text-2xl uppercase text-center tracking-widest m-3 my-6">
          Enter authentication code
        </h1>
        <FTUWizardHeader wizardStepCount={4} wizardActiveStep={3} />

        <p className="my-3 mt-6">
          Please enter your 6-digit security code from the Google Authenticator app.
        </p>
        <Formik
          initialValues={{ code: '' }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
        >
          {({ isSubmitting }) => (
            <Form className="flex flex-col">
              <InputGreenNoDecoration
                name="code"
                placeholder="Google Authenticator Verification Code"
                className="w-full"
                autocompleteOff
              />

              {errorMessage && (
                <div className="flex">
                  <span className="text-alertColor text-sm font-semibold italic">
                    {errorMessage}
                  </span>
                </div>
              )}

              <div className="flex flex-row gap-4 md:my-8">
                <Button
                  className="w-full mt-6 uppercase"
                  disabled={isSubmitting}
                  onClick={() => setQrCodeRead(false)}
                  type="button"
                >
                  Back
                </Button>
                <Button className="w-full mt-6 uppercase" type="submit" disabled={isSubmitting}>
                  Continue
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </WizardWrapper>
    </Card>
  )
}
